// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{grid-column:1/-1;-ms-grid-column-span:2;grid-row:2}.trial{background-color:#bc53bd}.expired{background-color:#fe635f}.past-due{background-color:#3bafda}.sleep{background-color:#5a308c}.trial-body{color:#fff;padding:0;height:auto;padding-bottom:3px}", ""]);
// Exports
module.exports = exports;
